import React from 'react'
import image from '../../../assets/homepage_pro10.png'
const LowerBannerFive = () => {
    return (
        <>
            <div className="cate-bx5 common">
                <div className="cate-pro">
                    <img className="img-fluid" src={image} alt="" />
                </div>
                <h3>
                    Impressa Z9 Mouse <span>Sophistication and extravagance</span>
                </h3>
                <a href="#" className="btn-buy">
                    Order Now
                </a>
            </div>

        </>
    )
}

export default LowerBannerFive